const INIT_STATE = {
  isModalActive: false,
  errorHeader: "",
  errorMessage: ""
}

export function ErrorModalReducer(state=INIT_STATE, action) {
  switch (action.type) {
    case "ERROR_MODAL_RESET":
      return {...INIT_STATE};

    case "ERROR_MODAL_PROMPT_ERROR":
      const error = getErrorDetails(action);
      return {...state, isModalActive: true, errorHeader: error.header, errorMessage: error.message};

    default:
      return state;
  }
}

function getErrorDetails(action) {
  const DEFAULT_ERROR = { header: "Unknown Error!", message: "An unexpected error has occured." };

  const ERROR_COLLECTION = {
    ADDING_CUSTOMER_TO_SALE_ERROR: { header: "Adding Customer to Sale Error", message: action.errorMessage },
    ADDING_ITEM_TO_SALE_ERROR: { header: "Adding Item to Sale Error", message: action.errorMessage },
    ADDING_RETURN_TO_SALE_ERROR: { header: "Adding Return To Sale Error", message: action.errorMessage },
    ADDING_SALES_REP_TO_SALE_ERROR: { header: "Adding Sales Rep to Sale Error", message: action.errorMessage },
    ADDING_TRANSACTION_TO_SALE_ERROR: { header: "Adding Transaction to Cart Error", message: action.errorMessage },
    CHECKOUT_PROCESS_ERROR: { header: "Check Out Process Error", message: action.errorMessage },
    EXISTING_CUSTOMER_ERROR: { header: "Existing Customer", message: "There is an existing customer on the cart." },
    EXISTING_TRANSACTION_ERROR: { header: "Existing Transaction", message: "There is an existing transaction on the cart. Park or void the transaction first, then try again." },
    PARK_TRANSACTION_RETRIEVAL_ERROR: { header: "Parked Transaction Retrieval Error", message: action.errorMessage },
    PARKING_TRANSACTION_ERROR: { header: "Parking Transaction Error", message: action.errorMessage },
    POST_VOID_LINE_ERROR: { header: "Post Voiding Line Error", message: action.errorMessage },
    POST_VOID_TRANSACTION_ERROR: { header: "Post Voiding Transaction Error", message: action.errorMessage },
    PUT_TRANSACTION_TO_DB_ERROR: { header: "Saving Transaction Error", message: action.errorMessage },
    SETTING_LINE_DISCOUNT_ERROR: { header: "Setting Line Discount Error", message: action.errorMessage },
    SETTING_LINE_QUANTITY_ERROR: { header: "Setting Line Quantity Error", message: action.errorMessage },
    SETTING_LINE_SALES_PRICE_ERROR: { header: "Setting Line Discount Error", message: action.errorMessage },
    VIEW_TRANSACTION_DETAILS_ERROR: { header: "Viewing Transaction Error", message: action.errorMessage  },
    VOID_LINE_ERROR: { header: "Voiding Line Error", message: action.errorMessage },
    VOID_TRANSACTION_ERROR: { header: "Voiding Transaction Error", message: action.errorMessage },
    HOTKEY_RETRIVAL_ERROR: { header: "Hotkey Retrieval Error", message: action.errorMessage },
    TASK_TRANSACTION_RETRIEVAL_ERROR: { header: "Task Retrieval Error", message: action.errorMessage },
    APPLICATION_INACTIVE: { header: 'You have been inactive', message: action.errorMessage },
  }

  return (ERROR_COLLECTION[action.errorType] || DEFAULT_ERROR);
}
